import { ISelectOption } from '../components';

export interface IUSAState {
  Short: string;
  Long: string;
}
export enum eUSAState {
  AL = 'AL',
  AK = 'AK',
  AZ = 'AZ',
  AR = 'AR',
  CA = 'CA',
  CO = 'CO',
  CT = 'CT',
  DE = 'DE',
  DC = 'DC',
  FL = 'FL',
  GA = 'GA',
  HI = 'HI',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  IA = 'IA',
  KS = 'KS',
  KY = 'KY',
  LA = 'LA',
  ME = 'ME',
  MD = 'MD',
  MA = 'MA',
  MI = 'MI',
  MN = 'MN',
  MS = 'MS',
  MO = 'MO',
  MT = 'MT',
  NE = 'NE',
  NM = 'NM',
  NV = 'NV',
  NH = 'NH',
  NJ = 'NJ',
  NY = 'NY',
  NC = 'NC',
  ND = 'ND',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  PA = 'PA',
  RI = 'RI',
  SC = 'SC',
  SD = 'SD',
  TN = 'TN',
  TX = 'TX',
  UT = 'UT',
  VT = 'VT',
  VA = 'VA',
  WA = 'WA',
  WV = 'WV',
  WI = 'WI',
  WY = 'WY',
}

export const States: IUSAState[] = [
  { Short: eUSAState.AL, Long: 'Alabama' },
  { Short: eUSAState.AK, Long: 'Alaska' },
  { Short: eUSAState.AZ, Long: 'Arizona' },
  { Short: eUSAState.AR, Long: 'Arkansas' },
  { Short: eUSAState.CA, Long: 'California' },
  { Short: eUSAState.CO, Long: 'Colorado' },
  { Short: eUSAState.CT, Long: 'Connecticut' },
  { Short: eUSAState.DE, Long: 'Delaware' },
  { Short: eUSAState.DC, Long: 'District of Columbia' },
  { Short: eUSAState.FL, Long: 'Florida' },
  { Short: eUSAState.GA, Long: 'Georgia' },
  { Short: eUSAState.HI, Long: 'Hawaii' },
  { Short: eUSAState.ID, Long: 'Idaho' },
  { Short: eUSAState.IL, Long: 'Illinois' },
  { Short: eUSAState.IN, Long: 'Indiana' },
  { Short: eUSAState.IA, Long: 'Iowa' },
  { Short: eUSAState.KS, Long: 'Kansas' },
  { Short: eUSAState.KY, Long: 'Kentucky' },
  { Short: eUSAState.LA, Long: 'Louisiana' },
  { Short: eUSAState.ME, Long: 'Maine' },
  { Short: eUSAState.MD, Long: 'Maryland' },
  { Short: eUSAState.MA, Long: 'Massachusetts' },
  { Short: eUSAState.MI, Long: 'Michigan' },
  { Short: eUSAState.MN, Long: 'Minnesota' },
  { Short: eUSAState.MS, Long: 'Mississippi' },
  { Short: eUSAState.MO, Long: 'Missouri' },
  { Short: eUSAState.MT, Long: 'Montana' },
  { Short: eUSAState.NE, Long: 'Nebraska' },
  { Short: eUSAState.NV, Long: 'Nevada' },
  { Short: eUSAState.NH, Long: 'New Hampshire' },
  { Short: eUSAState.NJ, Long: 'New Jersey' },
  { Short: eUSAState.NM, Long: 'New Mexico' },
  { Short: eUSAState.NY, Long: 'New York' },
  { Short: eUSAState.NC, Long: 'North Carolina' },
  { Short: eUSAState.ND, Long: 'North Dakota' },
  { Short: eUSAState.OH, Long: 'Ohio' },
  { Short: eUSAState.OK, Long: 'Oklahoma' },
  { Short: eUSAState.OR, Long: 'Oregon' },
  { Short: eUSAState.PA, Long: 'Pennsylvania' },
  { Short: eUSAState.RI, Long: 'Rhode Island' },
  { Short: eUSAState.SC, Long: 'South Carolina' },
  { Short: eUSAState.SD, Long: 'South Dakota' },
  { Short: eUSAState.TN, Long: 'Tennessee' },
  { Short: eUSAState.TX, Long: 'Texas' },
  { Short: eUSAState.UT, Long: 'Utah' },
  { Short: eUSAState.VT, Long: 'Vermont' },
  { Short: eUSAState.VA, Long: 'Virginia' },
  { Short: eUSAState.WA, Long: 'Washington' },
  { Short: eUSAState.WV, Long: 'West Virginia' },
  { Short: eUSAState.WI, Long: 'Wisconsin' },
  { Short: eUSAState.WY, Long: 'Wyoming' },
];

export const StatesLabelValue: ISelectOption<string>[] = States.map((t) => ({
  label: `${t.Short} (${t.Long})`,
  value: t.Short,
}));
export const StatesLabelValueId = States.map((t) => ({ label: `${t.Short} (${t.Long})`, value: t.Short, id: t.Short }));

export const StateAbbreviationToLongName: Record<eUSAState, string> = {
  [eUSAState.AL]: 'Alabama',
  [eUSAState.AK]: 'Alaska',
  [eUSAState.AZ]: 'Arizona',
  [eUSAState.AR]: 'Arkansas',
  [eUSAState.CA]: 'California',
  [eUSAState.CO]: 'Colorado',
  [eUSAState.CT]: 'Connecticut',
  [eUSAState.DE]: 'Delaware',
  [eUSAState.DC]: 'District of Columbia',
  [eUSAState.FL]: 'Florida',
  [eUSAState.GA]: 'Georgia',
  [eUSAState.HI]: 'Hawaii',
  [eUSAState.ID]: 'Idaho',
  [eUSAState.IL]: 'Illinois',
  [eUSAState.IN]: 'Indiana',
  [eUSAState.IA]: 'Iowa',
  [eUSAState.KS]: 'Kansas',
  [eUSAState.KY]: 'Kentucky',
  [eUSAState.LA]: 'Louisiana',
  [eUSAState.ME]: 'Maine',
  [eUSAState.MD]: 'Maryland',
  [eUSAState.MA]: 'Massachusetts',
  [eUSAState.MI]: 'Michigan',
  [eUSAState.MN]: 'Minnesota',
  [eUSAState.MS]: 'Mississippi',
  [eUSAState.MO]: 'Missouri',
  [eUSAState.MT]: 'Montana',
  [eUSAState.NE]: 'Nebraska',
  [eUSAState.NV]: 'Nevada',
  [eUSAState.NH]: 'New Hampshire',
  [eUSAState.NJ]: 'New Jersey',
  [eUSAState.NM]: 'New Mexico',
  [eUSAState.NY]: 'New York',
  [eUSAState.NC]: 'North Carolina',
  [eUSAState.ND]: 'North Dakota',
  [eUSAState.OH]: 'Ohio',
  [eUSAState.OK]: 'Oklahoma',
  [eUSAState.OR]: 'Oregon',
  [eUSAState.PA]: 'Pennsylvania',
  [eUSAState.RI]: 'Rhode Island',
  [eUSAState.SC]: 'South Carolina',
  [eUSAState.SD]: 'South Dakota',
  [eUSAState.TN]: 'Tennessee',
  [eUSAState.TX]: 'Texas',
  [eUSAState.UT]: 'Utah',
  [eUSAState.VT]: 'Vermont',
  [eUSAState.VA]: 'Virginia',
  [eUSAState.WA]: 'Washington',
  [eUSAState.WV]: 'West Virginia',
  [eUSAState.WI]: 'Wisconsin',
  [eUSAState.WY]: 'Wyoming',
};
